import {
  type FC,
  type HTMLProps,
  memo,
  type MouseEventHandler,
  type ReactElement,
} from 'react';

import classNames from 'classnames';

import CheckIcon from '@yourcoach/shared/assets/icons/check.svg';

import styles from './Checkbox.module.css';

interface Props extends Omit<HTMLProps<HTMLDivElement>, 'label'> {
  checked?: boolean;
  className?: string;
  isDisabled?: boolean;
  label?: ReactElement<any> | string;
  onClick?: MouseEventHandler;
  testID?: string;
  variant?: 'round';
}

const Checkbox: FC<Props> = ({
  checked,
  className,
  isDisabled,
  label,
  onClick,
  testID,
  variant,
  ...props
}) => {
  return (
    <div
      className={classNames(
        'Checkbox',
        styles.Checkbox,
        variant && styles[variant],
        isDisabled && styles.disabled,
        className,
      )}
      onClick={!isDisabled ? onClick : undefined}
      {...props}
    >
      <div className={styles.checkMark} data-test-id={testID}>
        {checked ? <CheckIcon /> : null}
      </div>
      {label ? <p className={styles.label}>{label}</p> : null}
    </div>
  );
};

export default memo(Checkbox);
